function normalizeText(text: string): string {
	return text
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^\w\s]/g, '')
		.replace(/\s+/g, '_')
		.toLowerCase();
}

export {normalizeText};
